"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var space_1 = __importDefault(require("../foundations/space"));
var Avatar = {
    parts: ['container', 'label'],
    sizes: {
        md: {
            container: {
                height: space_1.default[9],
                width: space_1.default[9],
            },
            label: {
                fontSize: '90%',
            },
        },
    },
};
exports.default = Avatar;
